import { Ticket, CalendarDays, MapPin, Sparkles } from 'lucide-react';
import { howItWorks } from '../../data/mock';
import { useInView } from '../../hooks/useInView';

const iconMap = { Ticket, CalendarDays, MapPin, Sparkles };

export const HowItWorks = () => {
  const [ref, isInView] = useInView();

  return (
    <section id="how-it-works" className="section-gap bg-obsidian-light relative overflow-hidden">
      <div ref={ref} className="relative max-w-6xl mx-auto">
        {/* Header */}
        <div
          className={`text-center mb-20 transition-all duration-900 ${
            isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="flex items-center justify-center gap-4 mb-5">
            <div className="w-8 h-px bg-amber/20" />
            <span className="font-body text-[11px] tracking-[0.4em] uppercase text-amber/50">
              How It Works
            </span>
            <div className="w-8 h-px bg-amber/20" />
          </div>
          <h2 className="font-heading text-[2.5rem] md:text-[3.5rem] font-light text-ivory">
            Four Simple <em className="italic text-amber">Steps</em>
          </h2>
        </div>

        {/* Steps */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {howItWorks.map((step, index) => {
            const IconComp = iconMap[step.icon];
            return (
              <div
                key={step.step}
                className={`relative text-center transition-all duration-800 ${
                  isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                }`}
                style={{ transitionDelay: isInView ? `${index * 150 + 200}ms` : '0ms' }}
              >
                {/* Connector line */}
                {index < howItWorks.length - 1 && (
                  <div className="hidden lg:block absolute top-8 left-[65%] right-[-35%] h-px bg-gradient-to-r from-amber/10 to-transparent" />
                )}

                {/* Step circle */}
                <div className="relative inline-flex items-center justify-center w-16 h-16 mb-7">
                  <div className="absolute inset-0 rounded-full border border-amber/[0.08]" />
                  {IconComp && <IconComp size={20} className="text-amber/60" />}
                  <span className="absolute -top-1.5 -right-1.5 w-6 h-6 rounded-full bg-amber text-obsidian font-body text-[10px] font-bold flex items-center justify-center">
                    {step.step}
                  </span>
                </div>

                <h3 className="font-heading text-lg font-medium text-ivory/80 mb-2">
                  {step.title}
                </h3>
                <p className="font-body text-[13px] text-ivory/25 leading-relaxed font-light max-w-[200px] mx-auto">
                  {step.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
